export default {
  "bonusApproval.title": "Bonus Approval",
  "bonusApproval.copySuccess": "Copy Success!",

  "bonusApproval.search.createTime": "Create Time",
  "bonusApproval.search.rewardType": "Reward Type",
  "bonusApproval.search.status": "Status",

  "bonusApproval.column.index": "#NO",
  "bonusApproval.column.applyId": "Apply ID",
  "bonusApproval.column.userno": "UserNo",
  "bonusApproval.column.email": "Email",
  "bonusApproval.column.rewardType": "Reward Type",
  "bonusApproval.column.amount": "Amount",
  "bonusApproval.column.status": "Status",
  "bonusApproval.column.remark": "Remark",
  "bonusApproval.column.createTime": "Create Time",
  "bonusApproval.column.action": "Action",

  "bonusApproval.action.pass": "Pass",
  "bonusApproval.action.reject": "Reject",

  "bonusApproval.confirm.title": "{optWords} Approval",
  "bonusApproval.confirm.content": "Are you sure you want to {optWords} this claim?",
  "bonusApproval.confirm.ok": "Confirm",
  "bonusApproval.confirm.cancel": "Cancel",
  "bonusApproval.confirm.selectedIds": "Selected Apply IDs: {ids}",

  "bonusApproval.remark.placeholder": "Please enter remark (optional)",
};
